<template>
  <div>
    <v-radio-group
      :value="lpuFiltersState.timeWork.type"
      class="mt-0 pt-0"
      hide-details
      column
      mandatory
      @change="handleChangeType"
    >
      <v-radio
        v-for="(item, i) in items"
        :key="i"
        :value="item.value"
        class="my-3"
      >
        <template #label>
          <div
            class="text-body-1 text--text"
          >
            {{ t(item.name, options) }}
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <v-expand-transition>
      <div v-if="lpuFiltersState.timeWork.type === 'custom'">
        <div class="pt-2 pb-2">
          <WeekdaySelector
            :value="lpuFiltersState.timeWork.weekday"
            class="mb-6"
            @input="handleChangeWeekday"
          />
          <RangeTimeSelector
            :value="lpuFiltersState.timeWork.time"
            @input="handleChangeTime"
          />
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import { ref, toRefs } from 'vue'
import I18NextVue from 'i18next'
import WeekdaySelector from 'www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/components/WeekdaySelector/WeekdaySelector.vue'
import RangeTimeSelector from 'www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/components/RangeTimeSelector/RangeTimeSelector.vue'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

type TimeWorkType = Filters['timeWork']['type']
type TimeWorkWeekday = Extract<Filters['timeWork'], { type: 'custom' }>['weekday']
type TimeWorkTime = Extract<Filters['timeWork'], { type: 'custom' }>['time']

const emit = defineEmits(['input'])
const filtersStore = useFiltersStore()

const props = defineProps<{ value: Filters }>()
const { value: lpuFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = { ns: language }

const items = ref<{ name: string, value: TimeWorkType }[]>([
  { name: 'Любое', value: 'any' },
  { name: 'Открыто сейчас', value: 'open_now' },
  { name: 'Круглосуточно', value: '24_7' },
  { name: 'Укажу нужное время', value: 'custom' },
])

const handleChangeType = (type: TimeWorkType) => {
  if (type === 'custom') {
    emit('input', {
      ...lpuFiltersState.value,
      timeWork: {
        weekday: format(new Date(), 'EEEE').toLowerCase() as TimeWorkWeekday,
        time: { from: '00:00', to: '23:59' },
        ...filtersStore.filters.timeWork,
        type,
      },
    })

    return
  }

  emit('input', {
    ...lpuFiltersState.value,
    timeWork: { type },
  })
}

const handleChangeWeekday = (weekday: TimeWorkWeekday) => {
  emit('input', {
    ...lpuFiltersState.value,
    timeWork: { ...lpuFiltersState.value.timeWork, weekday },
  })
}
const handleChangeTime = (time: TimeWorkTime) => {
  emit('input', {
    ...lpuFiltersState.value,
    timeWork: { ...lpuFiltersState.value.timeWork, time },
  })
}
</script>
